<mat-tab-group
  [(selectedIndex)]="selectedTab"
  (selectedTabChange)="tabChanged($event)"
>
  <mat-tab label="Pendientes">
    <ng-template matTabContent>
      <app-eventos-genericos-vivos></app-eventos-genericos-vivos>
    </ng-template>
  </mat-tab>
  <mat-tab label="Espera">
    <ng-template matTabContent>
      <app-eventos-genericos-espera></app-eventos-genericos-espera>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historial">
    <ng-template matTabContent>
      <app-eventos-genericos-historico></app-eventos-genericos-historico>
    </ng-template>
  </mat-tab>
  <!-- Sirena tab removed; we keep only 'Vivos' for now -->
</mat-tab-group>
